import { useSelector } from 'react-redux';
import {
  useQuery,
  DocumentNode,
  ApolloError,
  ApolloQueryResult,
  OperationVariables,
} from '@apollo/client';
import { RootState } from '../../../../store/store';
import { PaginationInput } from '../../../../types/schema/utils.types';
import { User } from '../../../../types/schema/user.types';

interface GetAllUserWalletsByPageHook {
  data: User[] | undefined;
  loading: boolean;
  error: ApolloError | undefined;
  refetch: (variables?: Partial<OperationVariables> | undefined) => Promise<
    ApolloQueryResult<{
      getAllUserWalletsByPage: User[];
    }>
  >;
}

interface GetAllUserWalletsByPageMutationData {
  getAllUserWalletsByPage: User[];
}

interface GetAllUserWalletsByPageInputType {
  input: PaginationInput;
}

export function useGetAllUserWalletsByPage(
  query: DocumentNode,
  input: PaginationInput
): GetAllUserWalletsByPageHook {
  const { jwt } = useSelector((state: RootState) => state.auth);

  const { data, loading, error, refetch } = useQuery<
    GetAllUserWalletsByPageMutationData,
    GetAllUserWalletsByPageInputType
  >(query, {
    variables: {
      input,
    },
    context: {
      headers: {
        cookie: `jwt=${jwt}`,
        authorization: jwt ? `Bearer ${jwt}` : '',
      },
    },
  });

  return {
    data: data?.getAllUserWalletsByPage,
    loading,
    error,
    refetch,
  };
}
